import React from "react";
import AllNumbers from "./AllNumbers";

export default function PhoneInventoryContainer() {
  return <AllNumbers />;
}
